import { Facility, Option } from 'types';

export const facilitiesFilterOptionsMap = (
  facilities?: Facility[],
  predefinedOptions: Option[] = [],
) => {
  if (!facilities) return [...predefinedOptions];

  const companiesOptions = facilities.map((facility) => ({
    label: facility.name,
    value: facility.id,
  }));

  return [...predefinedOptions, ...companiesOptions];
};
export const monthNameToNumber = (monthName: string): number => {
  const months = [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec',
  ];
  const shortName = monthName.toLowerCase().slice(0, 3);
  const idx = months.indexOf(shortName);

  return idx >= 0 ? idx + 1 : NaN; // returns 1-based month number or NaN
};
export const cardColors: Record<string, string> = {
  'Total Revenue': '#3F81F7',
  'Total Booking': '#AE80EA',
  'Overall Wallet Amount': '#14B8A6',
};
export const cardColorsFacilites: Record<string, string> = {
  'Number Of Facilities': '#7259FE',
  Location: '#E3BB39',
  Courts: '#F36363',
  'Number Of Academies': '#3443eb',
};
